import React from 'react';
import { makeStyles, Button } from '@material-ui/core';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { dataService } from '../../Services/data.service';
import CachedIcon from '@mui/icons-material/Cached';

export default function SyncTile() {
    const classes = useStyles();
    const { t } = useTranslation();

    function ResyncOrders() {
        dataService.resyncOrders().then(() => {
            toast.success(t('resync ok'), { position: "top-center" })
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }

    return (
        <div className={classes.tile}>
            <div className={classes.line}>
                {t("SYNC")}
            </div>
            <div className={classes.iconContainer}>

                <CachedIcon className={classes.syncIcon} alt={""}></CachedIcon>
            </div>
            <div className={classes.lineId}>
                <Button className={classes.syncButton} onClick={() => ResyncOrders()}>{t("Resync orders")}</Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    line: {
        color: "#8D8D8D",
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingTop: "5px",
        paddingBottom: "5px"

    },
    lineId: {
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "10px"
    },
    iconContainer: {
        margin: "20px",
        textAlign: "center"
    },
    tile: {
        height: "220px",
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",
    },
    syncButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "200px",
        height: "40px",
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        },
    },
    syncIcon: {
        width: "100px",
        height: "100px",
        fontSize: '100px !important',
    },
}));